import axios from "axios";

export const getSlider = async (page = 1) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/sliders", {
      params: {
        page
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postSlider = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/sliders", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getSliderById = async (id, selectedLangCode) => {
  try {
    const brear = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");

    if (selectedLangCode) {
      lang = selectedLangCode;
    }
    const { data } = await axios.get(`/v1/admin/sliders/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateSlider = async (id, postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/sliders/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteSlider = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const Swal = require("sweetalert2");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/sliders/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export const getCategoriesForSlider = async () => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/categories", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getStoresForSlider = async () => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/stores", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getProductsForSlider = async () => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
   
    const { data } = await axios.get("/v1/admin/products", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
